globalThis["__sentryRewritesTunnelPath__"] = undefined;
globalThis["SENTRY_RELEASE"] = {"id":"afeab309f117e22646289d943f54dc5fccf6d46b"};
globalThis["__sentryBasePath"] = undefined;
globalThis["__rewriteFramesAssetPrefixPath__"] = "";
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// https://once-upon.sentry.io/issues/?project=5993162
import * as Sentry from '@sentry/nextjs'
import {
  shouldIgnoreKundoError,
  shouldIgnoreInvariantNavigationError,
  shouldIgnoreJavaEnabledError,
  shouldIgnoreUnhandledRejectionError,
  shouldIgnoreExtensionMessagingError,
} from './lib/sentry-filters'

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN
const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

if (isProduction) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
    environment: 'production',
    integrations: [Sentry.browserTracingIntegration()],
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.2,

    beforeSend(event) {
      if (
        shouldIgnoreKundoError(event) ||
        shouldIgnoreInvariantNavigationError(event) ||
        shouldIgnoreJavaEnabledError(event) ||
        shouldIgnoreUnhandledRejectionError(event) ||
        shouldIgnoreExtensionMessagingError(event)
      ) {
        return null
      }

      return event
    },
  })
} else if (isPreview) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
    environment: 'preview',
    integrations: [Sentry.browserTracingIntegration()],
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0,

    beforeSend(event) {
      if (
        shouldIgnoreKundoError(event) ||
        shouldIgnoreInvariantNavigationError(event) ||
        shouldIgnoreJavaEnabledError(event) ||
        shouldIgnoreUnhandledRejectionError(event) ||
        shouldIgnoreExtensionMessagingError(event)
      ) {
        return null
      }

      return event
    },
  })
} else {
  /* Sentry.init({
    enabled: false,
  }) */
  // uncomment this if you want to enable Sentry in development, and comment out the above Sentry.init
  Sentry.init({
    dsn: SENTRY_DSN,
    release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
    // debug: true,
    environment: 'development',
    integrations: [Sentry.browserTracingIntegration()],
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0,

    beforeSend(event) {
      if (
        shouldIgnoreKundoError(event) ||
        shouldIgnoreInvariantNavigationError(event) ||
        shouldIgnoreJavaEnabledError(event) ||
        shouldIgnoreUnhandledRejectionError(event) ||
        shouldIgnoreExtensionMessagingError(event)
      ) {
        return null
      }

      return event
    },
  })
}
